













import { Component, Vue } from "vue-property-decorator";
@Component({ components: {} })
export default class KioskAttendReports extends Vue {
  get reportUrl() {
    return this.$route.params.reportUrl;
  }
}
